export default "__VITE_ASSET__D0OBNV5___"